export default __webpack_public_path__ + "static/media/jumping-2194230-0.0af39be0.svg";